export default __webpack_public_path__ + "static/media/ipad.1a2b8af2.png";